<app-block-list
  [blockIdList]="body"
  class="flex flex-col min-h-screen"
></app-block-list>
